module.exports = __webpack_public_path__ + "static/media/truck-plow.f51ba3ba.svg";